import { foramtFireProtectionMaterial } from "@/utils/formatProductDetail";
import { AllFireProtectionMaterials } from "@/consts/ProductDetail";
import { SelectionProps } from "@/interfaces/SelectionProps";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import RadioTile from "@/components/RadioTile";
import SearchScafold from "@/components/SearchScafold";

const registerKey = "fire_protection_material";

export type FireProtectionMaterialFormField = Pick<
  ProductSearchQueryParameter,
  "fire_protection_material"
>;

const FireProtectionMaterialSelection: FC<
  SelectionProps<FireProtectionMaterialFormField>
> = ({ defaultValue, onUpdate, onBack }): JSX.Element => {
  const { register, handleSubmit } = useForm<FireProtectionMaterialFormField>();

  return (
    <SearchScafold
      handleSubmit={handleSubmit((data) => {
        onUpdate(data);
        onBack();
      })}
      title={"防火材料"}
    >
      <ul className="BorderList">
        <li>
          <RadioTile
            defaultChecked={defaultValue.fire_protection_material === ""}
            value={""}
            register={register(registerKey)}
            label={"指定なし"}
          />
        </li>

        {AllFireProtectionMaterials.map((value) => {
          return (
            <li key={value}>
              <RadioTile
                defaultChecked={
                  defaultValue.fire_protection_material === value.toString()
                }
                value={value.toString()}
                register={register(registerKey)}
                label={foramtFireProtectionMaterial(value)}
              />
            </li>
          );
        })}
      </ul>
    </SearchScafold>
  );
};
export default FireProtectionMaterialSelection;
